import React from 'react';
import Head from 'next/head';
import ReactGA from 'react-ga4';
import BaseLayout from 'layouts/BaseLayout';
import Header from 'components/BiorenderAlternative/Header';
import MainContent from 'components/BiorenderAlternative/MainContent';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function BiorenderAlternativePage() {
  const { user } = useAuthUser();

  function sendClickTrackingEvents() {
    ReactGA.event({
      category: 'landing_page',
      action: 'biorender_alternative_clicked',
      label: 'When user clicks on the first button',
      value: user.id,
    });
  }

  return (
    <BaseLayout hero={<Header />} hasPadding={false}>
      <Head>
        <title>The Best Biorender Alternatives to Communicate Science - Mind the Graph</title>

        <meta
          name="description"
          content="Connect more people to your work with a more diverse, easy-to-use, and cheaper Biorender alternative."
        />
      </Head>

      <MainContent onActionClick={sendClickTrackingEvents} />
    </BaseLayout>
  );
}
